export enum bodiesEnum {
    A = 'A',
    B = 'B'
}